import { IPadDetailTreatment, IPadDetailWell, IPadRealtimeInputData, PadRealtimeDataService } from './../pad-realtime-data.service';
import { finalize } from 'rxjs/operators';
import { TreatmentSettingsService } from './../../../shared/services/treatment-settings.service';
import { TIME_SETTING_TYPE, TREATMENT_MONITOR_NUMBER } from './../../../shared/helpers/app.constants';
import { some, find, findIndex, maxBy, cloneDeep } from 'lodash';
import { IWellsCompareInputData, WellsCompareDataService } from './../../wells/wells-compare-data.service';
import { CustomRelatedColumnComponent } from '../../../shared/components/custom-smart-table/custom-related-column.component';
import { Helper } from './../../../shared/helpers/helper';
import { PadService } from './../../../shared/services/pad.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { pipe, Subscription } from 'rxjs';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { LoadingOverlayService } from '../../../shared/services/loading-overlay.service';
import { UserAuthService } from '../../../shared/services/user-auth.service';
import { UserRolesService } from '../../../shared/services/user-roles.service';
import * as moment from 'moment';
import { CustomSwitchColumnComponent } from '../../../shared/components/custom-smart-table/custome-switch-column/custome-switch-column.component';
import { TreatmentService } from '../../../shared/services/treatment.service';

@Component({
  selector: 'app-pad-details',
  templateUrl: './pad-details.component.html',
  styleUrls: ['./pad-details.component.scss']
})
export class PadDetailsComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  // padName
  padName: string;
  companyId: string | number;

  isDataFiles: boolean = false;

  // loading: boolean = true;
  notFoundData: boolean;
  isDisabledCompare: boolean = false;
  isUpdateInProgress = false;

  paramPads: any;

  // Table Well
  listWells: IPadDetailWell[] = [];
  listCompareWells: IPadDetailWell[] = [];
  tableWellSettings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    hideSubHeader: true,
    attr: {
      class: 'last-column-text-left',
    },
    pager: {
      perPage: 20,
    },
    columns: {
      wellName: {
        title: 'Well Name',
        type: 'custom',
        width: '40%',
        renderComponent: CustomRelatedColumnComponent,
        onComponentInitFunction: (instance) => {
          instance.columnClick.subscribe(data => {
            this.openWellSummary(data);
          });
        }
      },
      completionDateDisplay: {
        title: 'Complete Date Time',
        width: '30%',
      },
      lastTreatment: {
        title: 'Last Treatment',
        type: 'custom',
        width: '30%',
        sort: false,
        renderComponent: CustomRelatedColumnComponent,
        onComponentInitFunction: (instance) => {
          instance.columnClick.subscribe(data => {
            this.openTreatmentDetails(data);
          });
        }
      }
    }
  };


  // treatment table
  listTreatmentsInProgress: IPadDetailTreatment[] = [];
  tableTreatmentSettings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    hideSubHeader: true,
    attr: {
      class: 'last-column-text-left',
    },
    columns: {
      wellName: {
        title: 'Well Name',
        type: 'string',
        width: '40%',
      },
      treatmentName: {
        title: 'Treatment',
        type: 'custom',
        width: '30%',
        sort: false,
        renderComponent: CustomRelatedColumnComponent,
        onComponentInitFunction: (instance) => {
          instance.columnClick.subscribe(data => {
            this.openTreatmentDetails(data);
          });
        }
      },
      treatmentComplete: {
        title: 'Complete',
        type: 'custom',
        width: '30%',
        sort: false,
        editable: true,
        renderComponent: CustomSwitchColumnComponent,
        onComponentInitFunction: (instance) => {
          instance.onEdited.subscribe(data => {
            this.updateInProgress(data);
          });
        }
      }
    }
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingOverlayService: LoadingOverlayService,
    private padService: PadService,
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService,
    private wellsCompareDataService: WellsCompareDataService,
    private treatmentSettingsService: TreatmentSettingsService,
    private padRealtimeDataService: PadRealtimeDataService,
    private treatmentService: TreatmentService
  ) {
    const userInfo = this.userAuthService.getUserInfo();
    const userRole = this.userRolesService.toUserRole(userInfo);
    this.companyId = userInfo.companyId || '';
    if (this.userAuthService.isCarboUser()) {
      if (!this.userRolesService.isFieldEngineer(userRole)) {
        this.isDataFiles = true;
      }
    } else if (!this.userRolesService.isFieldEngineer(userRole)) {
      this.isDataFiles = userInfo.canHaveDataFiles;
    }
  }

  ngOnInit() {
    this.loadingOverlayService.show();
    this.subscriptions.push(
      this.route.params.subscribe((params: any) => {
        const padName = params.padName;
        if (typeof padName === 'string') {
          this.padName = padName;
          this.getPadSummary(padName);
        } else {
          this.notFoundData = false;
          this.loadingOverlayService.hide();
        }
      })
    );
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  private getPadSummary(padName: string): void {
    this.subscriptions.push(
      this.padService.getPadByName(padName)
        .pipe(finalize(() => this.loadingOverlayService.hide()))
        .subscribe(
          (res) => {
            this.handleParamPads(res.result);
            this.notFoundData = true;
          }, (error) => {
            this.notFoundData = false;
          }
        )
    );
  }

  private transformWellCompletionDate(completionDate: string, well: any): string {
    const timeFormat = 'HH:mm, DD MMM YYYY';
    let formattedDate = moment(completionDate).utcOffset(0).format(timeFormat);
    if (well.timeZone) {
      const dayLight = well.dayLight ? well.dayLight : (well.treatmentList && well.treatmentList[0] ? well.treatmentList[0].dayLight : 0);
      const timezoneOffset = (well.timeZone + dayLight) / 60; // in minutes
      formattedDate = moment(completionDate).utcOffset(timezoneOffset).format(timeFormat);
    }
    return formattedDate;
  }

  private parseTreatment = (well, treatment): any => {
    let result = {} as any;
    result = Object.assign(treatment, {
      wellId: well.wellId,
      wellName: well.wellName,
      timeZone: well.timeZone,
      stTimeZone: well.stTimeZone,
      tzTimeZone: well.tzTimeZone,
      dayLight: treatment.dayLight || well.dayLight || 0,
      treatmentComplete: !treatment.inProgress
    });
    return result;
  };

  private handleParamPads(data: any): void {
    if (data) {
      if (!data.wells || data.wells.length === 0) {
        data.numberOfWells = 0;
        this.listWells = [];
      } else {
        let startDate: number;
        let endDate: number;
        data.numberOfWells = data.wells.length;

        this.listWells = data.wells.map(well => {
          // handle field name
          well.padName = this.padName;
          well.wellId = well.id !== undefined ? well.id : well.wellId;
          well.wellUid = well.wellAPI !== undefined ? well.wellAPI : well.wellUid;
          well.formation = data.formationName;
          well.formationName = data.formationName;
          well.operator = data.operatorName;
          well.operatorName = data.operatorName;
          well.serviceName = data.serviceName;
          well.serviceCompany = well.serviceName;
          if (!well.tzTimeZone || well.tzTimeZone === '') {
            well.tzTimeZone = Helper.lookupTimeZone(well.country, well.timeZone);
          }
          // Complete Date Time
          if (!well.timeEnd) {
            well.completionDate = null;
            well.completionDateDisplay = null;
          }
          else {
            const completionTime = well.timeEnd * 1000;
            well.completionDate = Helper.toDateTimeString(completionTime);
            well.completionDateDisplay = this.transformWellCompletionDate(well.completionDate, well);
          }
          // get pad's startDate (minimum of any well that's in this Pad)
          // get pad's endDate (max of any well that's in this Pad)
          startDate = startDate !== undefined && startDate !== null ? startDate : well.timeStart;
          if (well.timeStart && well.timeStart < startDate) {
            startDate = well.timeStart;
          }
          endDate = endDate !== undefined && endDate !== null ? endDate : well.timeEnd;
          if (well.timeEnd && well.timeEnd > endDate) {
            endDate = well.timeEnd;
          }
          // append lastTreatment Item
          const lastTreatment: any = well.treatmentList.find(treatment => treatment.id === well.lastTreatmentId);
          if (lastTreatment) {
            lastTreatment['text'] = (lastTreatment.treatmentNumber > 0) ? `Treatment ${lastTreatment.treatmentNumber}` : lastTreatment.treatmentName;
            lastTreatment['color'] = !well.lastTreatmentInProgress ? 'red' : 'green';
            well.lastTreatment = lastTreatment;
          } else {
            well.lastTreatment = {
              id: well.lastTreatmentId,
              text: well.lastTreatmentId ? `Treatment ${well.lastTreatmentId}` : 'N/A',
              color: !well.lastTreatmentInProgress ? 'red' : 'green'
            };
          }
          // handle treatmentList
          well.treatmentList = !well.treatmentList ? [] : well.treatmentList.map(x => this.parseTreatment(well, x));
          return well;
        });
        data.startDate = startDate * 1000;
        data.endDate = endDate * 1000;
      }

      this.paramPads = data;
    } else {
      this.paramPads = null;
      this.listWells = [];
    }
    // Disabled compare if well hasn't treatment data
    this.listCompareWells = this.listWells.filter(well => well.treatmentList && well.treatmentList.length > 0);
    // init list treatment in progress
    this.initListTreatmentInProgress();
  }

  private initListTreatmentInProgress() {
    this.listTreatmentsInProgress = [];
    if (!this.listWells || !this.listWells.length) return;
    for (const well of this.listWells) {
      for (const treatment of well.treatmentList) {
        if (!treatment.treatmentComplete) this.listTreatmentsInProgress.push(treatment);
      }
    }
  }

  private openWellSummary({ rowData, cellValue }: { rowData: any, cellValue: any }): void {
    if (rowData) {
      this.router.navigate(['pages', 'wells', `${rowData.id}`]);
    }
  }

  private openTreatmentDetails({ rowData, cellValue }: { rowData: any, cellValue: any }): void {
    if (rowData) {
      this.router.navigate(['pages/wells/treatmentDetails', rowData.id], {
        queryParams: {
          wellName: rowData.wellName,
          wellUid: rowData.wellAPI,
          serviceCompanyName: rowData.serviceName,
          operatorName: rowData.operatorName,
          treatmentId: cellValue.id
        }
      });
    }
  }

  private updateInProgress({ rowData, cellValue }): void {
    if (rowData.wellId && rowData.id) {
      this.isUpdateInProgress = true;
      const finalize = () => { this.isUpdateInProgress = false; };
      this.treatmentService.updateInProgress(rowData.wellId, rowData.id, { inProgress: !cellValue }, finalize)
        .subscribe(
          () => {
            this.listWells = this.listWells.map(well => {
              if (well.wellId === rowData.wellId) {
                // handle treatmentUpdated Item
                const treatmentUpdated: any = well.treatmentList.find(treatment => treatment.id === rowData.id);
                if (treatmentUpdated) {
                  treatmentUpdated['inProgress'] = !cellValue;
                  treatmentUpdated['treatmentComplete'] = cellValue;
                }
                // update last treatment
                if (well.lastTreatmentId === rowData.id) {
                  well.lastTreatmentInProgress = !cellValue;
                  const text = treatmentUpdated
                    ? (treatmentUpdated.treatmentNumber > 0 ? `Treatment ${treatmentUpdated.treatmentNumber}` : treatmentUpdated.treatmentName)
                    : `Treatment ${well.lastTreatmentId}`;
                  const color = !!cellValue ? 'red' : 'green';
                  well.lastTreatment = {
                    id: well.lastTreatmentId,
                    text: text,
                    color: color
                  };
                }
              }
              return well;
            });
            this.listCompareWells = this.listWells.filter(well => well.treatmentList && well.treatmentList.length > 0);
          }
        );
    }
  }

  onWellSelect(event): void {
    if (event && !this.isUpdateInProgress) {
      this.openWellSummary({ rowData: event.data, cellValue: null });
    }
  }

  submitCompare(): void {
    if (this.listCompareWells && this.listCompareWells.length > 0) {
      const compareData: IWellsCompareInputData = {
        compareType: this.listCompareWells.length > 1 ? 'Multiple Wells' : 'Single Wells',
        parameterSelect: [],
        channelSelect: [],
        treatmentSelect: [],
        wellSelect: this.listCompareWells,
      };
      this.treatmentSettingsService.setInputData({ padName: this.padName, isPadWell: true });
      this.wellsCompareDataService.setInputData(compareData);
      this.router.navigate(['pages', 'wells', 'compare'], { queryParams: { padName: this.padName } });
    }
  }

  openPadRealtime(): void {
    // const wells = cloneDeep(this.listWells);
    // let treatmentList: any[] = [];
    // wells.forEach(well => { treatmentList = treatmentList.concat(well.treatmentList) })
    // const treatmentInProgress = maxBy(treatmentList, treatment => { return treatment.timeStart; });
    // const wellInProgress = treatmentInProgress ? wells.find(well => {
    //   return well.treatmentList.findIndex(treatment => treatment.id === treatmentInProgress.id) > -1;
    // }) : null;

    const inputData = this.padRealtimeDataService.getLatestInProgress(this.listWells, this.paramPads);
    if (!inputData) return;
    // this.padRealtimeDataService.setInputData(inputData);
    const navigationExtras: NavigationExtras = {
      state: inputData
    };
    this.router.navigate(['pages', 'pads', 'realtime', `${this.padName}`], navigationExtras);
  }

}
